import { Provider, Type, Injector } from '@angular/core';
import { environment } from '../../../environments/environment.dev';

/**
 * Provides a service dynamically based on the enableMocks environment variable.
 * @param token The injection token (usually the abstract class).
 * @param apiService The API implementation class.
 * @param mockService The Mock implementation class.
 */
export function provideCoreService<T>(
  token: any,
  apiService: Type<any>,
  mockService: Type<any>
): Provider {
  return {
    provide: token,
    useFactory: (injector: Injector) => {
      const impl = environment.enableMocks ? mockService : apiService;
      return injector.get(impl);
    },
    deps: [Injector]
  };
}
